import { render, staticRenderFns } from "./shopEmail.vue?vue&type=template&id=0dfb9f53&scoped=true&"
import script from "./shopEmail.vue?vue&type=script&lang=js&"
export * from "./shopEmail.vue?vue&type=script&lang=js&"
import style0 from "./shopEmail.vue?vue&type=style&index=0&id=0dfb9f53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb9f53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dfb9f53')) {
      api.createRecord('0dfb9f53', component.options)
    } else {
      api.reload('0dfb9f53', component.options)
    }
    module.hot.accept("./shopEmail.vue?vue&type=template&id=0dfb9f53&scoped=true&", function () {
      api.rerender('0dfb9f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/shopEmail.vue"
export default component.exports